import Repository from '@/repositories/Repository'
import RainRuiHistory from '@/models/RainRuiHistory'

export type RainRuiHistoryParams = {
  stationId: string
  range: {
    startTime: string
    endTime: string
  }
}

class HistoryRepository extends Repository {
  constructor() {
    super('/rain_rui_history')
  }

  async get(params: RainRuiHistoryParams) {
    const attributes = await super._post<RainRuiHistoryParams>(params)

    return new RainRuiHistory(attributes)
  }
}

export default HistoryRepository
